import CountryIndicators from './CountryIndicators';

export default CountryIndicators;
